export function parseTime(time, cFormat) {
    if (arguments.length === 0) {
        return null;
    }

    if (time === 0) {
        return '-';
    }

    if ((`${time}`).length === 10) {
        time = +time * 1000;
    }

    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
    let date;
    if (typeof time === 'object') {
        date = time;
    } else {
        date = new Date(parseInt(time, 10));
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
    };
    const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key];
        if (key === 'a') { return ['一', '二', '三', '四', '五', '六', '日'][value - 1]; }
        if (result.length > 0 && value < 10) {
            value = `0${value}`;
        }
        return value || 0;
    });
    return timeStr;
}

export function formatDate (time, fmt) {
    let date;
    date = new Date(time)
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
        'y+': date.getFullYear(),
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
        }
    }
    return fmt;
}

function padLeftZero (str) {
    return ('00' + str).substr(str.length);
}

// 截取当前数据到小数点后两位
export function numFilter(value) {
    const realVal = parseFloat(value).toFixed(2);
    return realVal;
}

//电话星号显示
export function starPhone(phoneNum){
    let str =  String(phoneNum),
        strLen = str.slice(-8,-4);
    return str.replace(strLen,"****");
}

//是否为纯数字
export function isNumber(val){
    var regPos = /^\d+(\.\d+)?$/; //非负浮点数
    var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
    if(regPos.test(val) || regNeg.test(val)){
        return true;
    }else{
        return false;
    }

}


//纯中文判断
export function isChinese(temp)
{
    let re=/[^\u4e00-\u9fa5]/;
    if(re.test(temp)) return false;
    return true;
}
//手机号判断
export function isMobile(temp)
{
    let re = /^1[3456789]\d{9}$/;
    if(re.test(temp)) return false;
    return true;
}

//邮箱判断
export function isEmail(temp)
{
    let re = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/; //正则表达式
    if(re.test(temp)) return false;
    return true;
}

//TODO

// 转换状态(套餐订单)
export function statusTransPackage(value) {
    let status = ''
    switch (value) {
        case 'NO_DELIVERY':
            status = '未配送'
            break;
        case 'DELIVERED':
            status = '配送中'
            break;
        case 'FINISHED':
            status = '已完成'
            break;
        case 'CANCELLED':
            status = '已取消'
            break;
        case 'EXPIRED':
            status = '已过期'
            break;
        default:
            break;
    }
    return status;
}
// 转换状态(套餐每期订单)
export function statusTransPackagePeriod(value) {
    let status = ''
    switch (value) {
        case 'NO_DELIVERY':
            status = '未配送'
            break;
        case 'DELIVERED':
            status = '已配送'
            break;
        case 'FINISHED':
            status = '已完成'
            break;
        case 'CANCELLED':
            status = '已取消'
            break;
        default:
            break;
    }
    return status;
}